import { BleClient, numberToUUID } from "@capacitor-community/bluetooth-le";
import { buffer, filter, map, Observable, share } from "rxjs";
import { decodeNotification } from "@/features/ble/utils/decodeNotification.ts";
import { assembleFragments } from "@/features/ble/utils/assembleFragments.ts";
import { ref } from "vue";

const streams = ref<Record<string, Record<string, Observable<DataView>>>>({});

const BLUFI_SERVICE = numberToUUID(0xffff);
const BLUFI_RD_CHARACTERISTIC = numberToUUID(0xff02); // Readable and callable
const BLUFI_WR_CHARACTERISTIC = numberToUUID(0xff01); // Writable

const createNotificationsStreams = (deviceId: string) => {
  console.log("createNotificationsStreams");

  const notifications$ = new Observable<DataView>((subscriber) => {
    BleClient.startNotifications(
      deviceId,
      BLUFI_SERVICE,
      BLUFI_RD_CHARACTERISTIC,
      (value) => {
        console.log("got value", value);
        subscriber.next(value);
      }
    );
  }).pipe(share());

  const decodedNotifications$ = notifications$.pipe(
    map(decodeNotification),
    share()
  );

  const isLastFrameFragment$ = decodedNotifications$.pipe(
    filter((decodeNotification) => !decodeNotification.hasSubsequentFragments)
  );

  const fullFrames$ = decodedNotifications$.pipe(
    buffer(isLastFrameFragment$),
    share({ resetOnRefCountZero: false })
  );

  const responses$ = fullFrames$.pipe(
    map((fragments) => assembleFragments(fragments)),
    share()
  );

  notifications$.subscribe((value) => {
    console.log("notification$", value);
  });
  decodedNotifications$.subscribe((value) => {
    console.log("decodedNotification$", value);
  });
  isLastFrameFragment$.subscribe((value) => {
    console.log("isLastFrameFragment$", value);
  });
  fullFrames$.subscribe((value) => {
    console.log("fullFrames$", value);
    console.log("assembled", assembleFragments(value));
    console.log(assembleFragments(value));
  });

  return {
    notifications$,
    decodedNotifications$,
    isLastFrameFragment$,
    fullFrames$,
    responses$,
  };
};

export const getDeviceNotificationsStream = (deviceId: string) => {
  if (!streams.value[deviceId]) {
    streams.value[deviceId] = createNotificationsStreams(deviceId);
  }

  console.log("returned streams", streams.value[deviceId]);

  return streams.value[deviceId];
};

export const resetNotificationStreams = () => {
  console.log("Resetting notification streams");
  streams.value = {};
};
